<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span><b-icon icon="file-earmark-check" aria-hidden="true"></b-icon></span>
          <span>SLA Seguimiento de PTI</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>SLA_Solicitud_PTI</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="subtitulos">
          Búsqueda de SLAs
        </b-col>
      </b-row>

      <b-row>
        <b-col>

          <b-row align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label >Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre del tipo de solicitud"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerSLA"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right">
              <b-button v-b-tooltip.hover title="Agregar área" variant="outline-success"
                        @click="agregar()">Agregar SLA
              </b-button>
            </b-col>

          </b-row>

        </b-col>
      </b-row>

    <!--   Tabla   -->

      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(sla)="row">
              {{row.item.sla}} días
            </template>
            <template v-slot:cell(codigoColor)="row">
              <b-icon icon="circle-fill" aria-hidden="true" font-scale="2" :style="{color: row.item.codigoColor}"></b-icon>
            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    title="Modificar Tipo de Solicitud"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                ><em class="fa fa-pencil"></em></b-button>
                <b-button
                    v-if="!row.item.registroActivo"
                    title="Activar tipo solicitud"
                    variant="outline-success"
                    size="sm"
                    @click="activarDesactivarSla(row.item)"
                ><em class="fa fa-undo"></em></b-button>
                <b-button v-else
                          title="Desactivar tipo solicitud"
                          variant="outline-danger"
                          size="sm"
                          @click="activarDesactivarSla(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>


  <!--  Modal  -->
    <b-modal
        v-model="show"
        :title="tituloModal"
        size="lg"
        scrollable
    >
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>

              <b-form-group align="left">
                <label>Tipo de solicitud
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="filter-square"></b-icon>
                  </b-input-group-prepend>
                  <v-select id="nombreMenu" name="nombreMenu" placeholder="Selecciona un tipo"
                            v-model="$v.sla.idTipoSolicitud.$model"
                            label="descripcion"
                            style="width: 95%"
                            :reduce="(variable) => variable.idTipoSolicitud"
                            :options="tiposSolicitud"
                            :state="validateState('idTipoSolicitud')"
                            :class="selectClass('idTipoSolicitud')"
                  >
                  </v-select>
                </b-input-group>
              </b-form-group>

              <b-form-group align="left">
                <label>SLA (en días):
                  <validacion />
                </label>
                <b-input-group size="sm" class="mb-2" id="nombre">
                  <b-input-group-prepend is-text>
                    <b-icon icon="calendar4-week"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="SLA"
                                type="number"
                                v-model="$v.sla.sla.$model"
                                :state="validateState('sla')"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>


              <b-form-group align="left">
                <label>Color
                  <validacion/>
                </label>
                <b-input-group size="sm" class="mb-2">
                  <b-input-group-prepend is-text>
                    <b-icon icon="brush"></b-icon>
                  </b-input-group-prepend>
                  <v-select id="nombreMenu" name="nombreMenu" placeholder="Color del semaforo"
                            v-model="$v.sla.idColor.$model"
                            label="nombre"
                            style="width: 95%"
                            :reduce="(variable) => variable.idColor"
                            :options="colores"
                            :state="validateState('idColor')"
                            :class="selectClass('idColor')"

                  >
                    <template v-slot:option="option">
                      <em class="fa fa-circle" :style="{color: option.codigo}"> </em> {{ option.nombre }}

                    </template>
                  </v-select>
                </b-input-group>
              </b-form-group>

            </b-col>

          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" @click="guardar" :disabled="loaderAcciones">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
                        <b-spinner small></b-spinner>
                        Cargando...
                    </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal()">Cancelar</b-button>
      </template>

    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header";
import {required} from "vuelidate/lib/validators";
export default {
  name: "SLASeguimientoPTI",
  components: {Header},
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null
    },
    datosTabla: [],
    sla: {
      idSla: null,
      idTipoSolicitud: null,
      sla: null,
      idColor: null,
      registroActivo: null
    },
    tituloModal: "",
    show: false,
    loader: false,
    fields: [
      { key: "idSla", label: "ID", sortable: true },
      { key: "tipoSolicitud", label: "Tipo de Solicitud", sortable: true },
      { key: "sla", label: "SLA", sortable: true },
      { key: "codigoColor", label: "Color", sortable: true },
      "Acciones",
    ],
    registrosPorPagina: 10,
    paginaActual: 0,
    colores: [],
    tiposSolicitud: [],
    loaderAcciones: false,
  }),
  validations: {
    sla: {
      idTipoSolicitud: {required},
      sla: {required},
      idColor: {required}
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.obtenerSLA();
    this.obtenerColores();
    this.obtenerTiposSolicitud();
  },
  methods: {
    obtenerSLA() {
      this.loader = true;
      this.$http
          .post(this.$api + "seguimiento/pti/obtener/sla", this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    agregar(){
      this.sla= {
        idSla: null,
        idTipoSolicitud: null,
        sla: null,
        idColor: null,
        registroActivo: null
      };
      this.tituloModal = "Agregar SLA";
      this.show = true;
    },
    guardar(){
      this.$v.sla.$touch();
      if (this.$v.sla.$anyError) {
        return;
      }

      if (!this.$v.sla.$invalid) {
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'seguimiento/pti/guardarSla', this.sla).then(respuesta => {
              if (respuesta.data.data) {
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El SLA se registró correctamente",
                });
                this.filtro= {
                  id: null,
                  palabraClave: null,
                  registroActivo: null
                }
                this.obtenerSLA();
                this.show = false;
              }
            }
        ).catch(error => {
          console.error(error);
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "El SLA ya existe",
          });
        }).finally(() => {
              this.loaderAcciones = false;
            }
        )
      }

    },
    modificar(item){
      this.sla = item;
      this.tituloModal = "Modificar SLA";
      this.show = true;
    },
    activarDesactivarSla(item){
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar el SLA?' : '¿Está seguro de activar el SLA?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const parametros = {
            idSla: item.idSla,
          };
          this.$http.post(this.$api + 'seguimiento/pti/desactivarActivarSla',
              parametros
          ).then(respuesta => {
                if (respuesta.data.data) {
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "El tipo de solicitud se actualizó correctamente",
                  });
                }
              }
          )
        }
      })
    },
    obtenerColores() {
      this.$http.get(this.$api + 'catalogos/obtener/colores').then(
          respuesta => {
            if (respuesta.data.data) {
              this.colores = respuesta.data.data;
            }

          }
      )
    },
    obtenerTiposSolicitud() {
      let filtroSolicitud = {
        id: null,
        palabraClave: null,
        registroActivo: true
      };
      this.$http.post(this.$api + 'catalogos/obtenerTiposSolicitud', filtroSolicitud).then(
          respuesta => {
            if (respuesta.data.data) {
              this.tiposSolicitud = respuesta.data.data;
            }

          }
      )
    },
    cerrarModal() {
      this.show = false;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.sla[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute)
      if (state) {
        return 'border rounded-lg border-success'
      } else if (state === false) {
        return 'border rounded-lg border-danger'
      } else {
        return ''
      }
    }
  }
}
</script>

<style scoped>

</style>
